import { useParams } from 'react-router-dom';
import './Card.scss';
import { useContext, useState, useEffect } from 'react';
import { ThemeContext } from '../../context';
import { FetchData } from '../../Services/Service'; // ← ON RÉUTILISE LE SERVICE

import FormationWindow from '../../components/FormationWindow/FormationWindow'

import period from '../../components/SelectMenu/periodes.json'; // ← Celui-là est OK (dans src/)

export default function Card() {
  const { theme } = useContext(ThemeContext);
  const { id } = useParams();

  const [specimen, setSpecimen] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    FetchData()
      .then((data) => {
        const found = data.find(element => element.ID === id);
        if (!found) {
          setError("Spécimen non trouvé");
        } else {
          setSpecimen(found);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erreur chargement Card :", err);
        setError("Impossible de charger les données");
        setLoading(false);
      });
  }, [id]);

  // Recherche de la période
  const getPeriode = () => {
    if (!specimen) return null;
    let periode = period.find(p => p.SOUS_ETAGE === specimen.SOUS_ETAGE);
    if (!periode) {
      periode = period.find(p => p.ETAGE === specimen.ETAGE);
    }
    return periode;
  };

  const periode = getPeriode();

  if (loading) {
    return (
      <main className={`card_${theme}`} id="card">
        <div className="loader">Chargement du spécimen...</div>
      </main>
    );
  }

  if (error || !specimen) {
    return (
      <main className={`card_${theme}`} id="card">
        <div className="error">Spécimen introuvable ou erreur de chargement</div>
      </main>
    );
  }

  return (
    <main className={`card_${theme}`} id="card">
      <div id="card_Gauche">
        <h1>{specimen.ESPECE}</h1>
        <p>{specimen.AUTEUR}</p>
        <img
          className='photo_specimen'
          src={`/Photos/Specimens/${specimen.SPECIMEN}.jpg`}
          alt={specimen.SPECIMEN}
          onError={(e) => {
            e.target.src = '/Photos/Specimens/default.jpg'; // image par défaut
          }}
        />
        <div>
          {specimen.DIMENSIONS}<br />
          {specimen.ORIGINE}<br />
          <FormationWindow formationName={specimen.FORMATION} />
        </div>
      </div>

      <div id="card_Droite">
        

        {/* Image de l'étage correspondant*/}
        {specimen.ETAGE && (
          <div className="etage-image-container">
            <img
              src={`/Photos/TimePaleoMaps/${specimen.ETAGE}.jpg`}
              alt={`Étape géologique : ${specimen.ETAGE}`}
              className="etage-image"
              onError={(e) => {
                e.target.style.display = 'none'; // Cache l'image si elle n'existe pas
              }}
            />
          </div>
        )}

        <h2>Sous-étage: {specimen.SOUS_ETAGE}</h2>

        <p>
          Étage: {specimen.ETAGE}<br />
          Époque: {periode.EPOQUE} ({specimen.EPOQUE})<br />
          Période: {specimen.PERIODE}<br />
          Ère: {specimen.ERE}
        </p>

        
      </div>
    </main>
  );
}